import React, { useState } from "react";

import { Box, Grid, Button } from "@material-ui/core";

import TextLabel from "../../../Shared/TextLabel";
import { changeToBRDate, formattedTime } from "../../../../utils/date";
import useStyles from "./styles";
import { downloadResume } from "../../../../api/scheduling";

import { createGetQueryToken } from "../../../../api/api-client";
import DialogMessage from "../../../Dialog"

function TabConfirmation(props) {
  const {
    value,
    index,
    setTab,
    editingItem,
    confirmed,
    addNewSchedule,
    scheduling,
    setEditingItem,
    holdConfigs,
    ...other
  } = props;

  const classes = useStyles();

  const [hasNotEnoughQuotas, setHasNotEnoughQuotas] = useState(false);

  const hdlConfirmSchedule = async () => {
    if (confirmed) {
      setTab(0);
      setEditingItem({});
    } else {
      const addResult = await addNewSchedule(editingItem);
      if (!addResult.success && addResult.message === "no-quota") {
        setHasNotEnoughQuotas(true);
      }
      holdConfigs(false);
    }
  }

  return (
    <>
      <Box
        role="tabpanel"
        width="100%"
        hidden={value !== index}
        id={`scrollable-auto-tabpanel-${index}`}
        aria-labelledby={`scrollable-auto-tab-${index}`}
        {...other}
      >
        {value === index && !confirmed && (
          <>
            <Box height="100%" width="100%" p={3}>
              <Grid container spacing={3}>
                <Grid item md={3} xs={12}>
                  <TextLabel
                    labelStyle={classes.label}
                    valueStyle={classes.value}
                    label="Tipo de Agendamento"
                    value={
                      editingItem.loadingType === 1
                        ? "Carregamento"
                        : "Descarregamento"
                    }
                  />
                </Grid>
                <Grid item md={5} xs={12}>
                  <TextLabel
                    labelStyle={classes.label}
                    valueStyle={classes.value}
                    label="Cliente/Fornecedor"
                    value={`${editingItem.nameClient} - ${editingItem.cliente}`}
                  />
                </Grid>
                <Grid item md={4} xs={12}>
                  <TextLabel
                    labelStyle={classes.label}
                    valueStyle={classes.value}
                    label="Número da NF"
                    value={editingItem.nf}
                  />
                </Grid>
                <Grid item md={3} xs={12}>
                  <TextLabel
                    labelStyle={classes.label}
                    valueStyle={classes.value}
                    label="Produto"
                    value={editingItem.productLabel}
                  />
                </Grid>
                <Grid item md={5} xs={12}>
                  <TextLabel
                    labelStyle={classes.label}
                    valueStyle={classes.value}
                    label="Unidade Cargill"
                    value={editingItem.branchLabel}
                  />
                </Grid>
                <Grid item md={4} xs={12}>
                  <TextLabel
                    labelStyle={classes.label}
                    valueStyle={classes.value}
                    label="Volume"
                    value={editingItem.volume}
                  />
                </Grid>
                <Grid item md={3} xs={12}>
                  <TextLabel
                    labelStyle={classes.label}
                    valueStyle={classes.value}
                    label="Placa do caminhão"
                    value={editingItem.driverPlate}
                  />
                </Grid>
                <Grid item md={5} xs={12}>
                  <TextLabel
                    labelStyle={classes.label}
                    valueStyle={classes.value}
                    label="Nome do motorista"
                    value={editingItem.driver}
                  />
                </Grid>
                <Grid item md={4} xs={12}>
                  <TextLabel
                    labelStyle={classes.label}
                    valueStyle={classes.value}
                    label="Número da CNH"
                    value={editingItem?.driverLicense}
                  />
                </Grid>
                <Grid item md={6} xs={12}>
                <Box
                      display="flex"
                      flexDirection="column"
                      alignItems={ "flex-start"}
                    >
                    <span className={classes.label}>Documentos</span>
                    <span className={classes.value}>

                      {
                          editingItem.driverLicenseImg && (<span>CNH: <a
                            href={createGetQueryToken(
                              "v1/Schedulings/file",
                              `key=${editingItem?.driverLicenseImg?.file_key}`
                            )}
                            target="_blank"
                            rel="noopener noreferrer"
                            >
                                {editingItem?.driverLicenseImg?.fileName}
                          </a>
                          </span>
                          )
                      }
                    </span>
                    <span className={classes.value}>
                      {
                          editingItem.truckDocumentImg && (<span>Documento do veículo: <a
                            href={createGetQueryToken(
                              "v1/Schedulings/file",
                              `key=${editingItem?.truckDocumentImg?.file_key}`
                            )}
                            target="_blank"
                            rel="noopener noreferrer"
                            >
                                {editingItem?.truckDocumentImg?.fileName}
                          </a>
                          </span>
                          )
                      }
                    </span>
                    <span className={classes.value}>
                      {editingItem.loadingType === 2 && editingItem.nfImg && (
                          <span>Nota Fiscal:
                            <a
                              href={createGetQueryToken(
                                "v1/Schedulings/file",
                                `key=${editingItem.nfImg.file_key}`
                              )}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              {editingItem.nfImg.fileName}
                            </a>
                          </span>
                        )}
                    </span>
                </Box>
                </Grid>
              </Grid>
            </Box>
            <Box
              height="100%"
              bgcolor="white"
              width="100%"
              justifyContent="space-between"
              alignItems="center"
              display="flex"
              flexDirection="row"
              p={3}
            >
              <TextLabel
                labelStyle={classes.value}
                valueStyle={classes.mainTitle}
                label="Data"
                value={changeToBRDate(editingItem.date)}
              />

              <TextLabel
                labelStyle={classes.value}
                valueStyle={classes.mainTitle}
                label="Turno"
                value={editingItem.turnLabel}
              />
              <TextLabel
                labelStyle={classes.value}
                valueStyle={classes.mainTitle}
                label="Horário"
                value={`${formattedTime(editingItem.starts_at)}~${formattedTime(editingItem.ends_at)}`}
              />
            </Box>
          </>
        )}
        {value === index && confirmed && (
          <>
            <Box
              height="100%"
              width="100%"
              p={3}
              alignItems="center"
              flexDirection="row"
              justifyContent="flex-end"
            >
              <Grid container spacing={3}>
                <Grid item md={12} xs={12}>
                  <TextLabel
                    labelStyle={classes.confirmation}
                    valueStyle={classes.message}
                    center={true}
                    label="Novo agendamento salvo com sucesso."
                    value="Para um novo agendamento é só clicar no botão abaixo e reiniciar o ciclo."
                  />
                </Grid>
              </Grid>
            </Box>
          </>
        )}
        <Box
          width="100%"
          justifyContent="space-between"
          alignItems="flex-end"
          display="flex"
          flexDirection="row"
          p={2}
        >
          <Button
            color="primary"
            variant="contained"
            autoFocus
            data-cy="backbutton-btn"
            id="backbutton-btn"
            size="large"
            disabled={confirmed}
            className={classes.backButton}
            onClick={() => {
              setTab(2);
            }}
          >
            Voltar
          </Button>

          <Box display="flex" flexDirection="row" p={2}>
            {confirmed && (
              <Button
                size="large"
                color="primary"
                variant="contained"
                data-cy="print-btn"
                id="print-btn"
                onClick={() => downloadResume(scheduling.id)}
                className={classes.downloadButton}
              >
                Imprimir PDF
              </Button>
            )}

            <Button
              color="primary"
              variant="contained"
              autoFocus
              size="large"
              data-cy="confirm-new-btn"
              id="confirm-new-btn"
              className={classes.nextButton}
              onClick={hdlConfirmSchedule}
            >
              {!confirmed ? "Confirmar" : "Novo Agendamento"}
            </Button>
          </Box>
        </Box>
      </Box>

        <DialogMessage
          subject="Quotas insuficientes!"
          message="Você não possui contas suficientes para finalizar esta reserva, volte para selecionar uma nova data."
          isOpen={hasNotEnoughQuotas}
          closeReadingNotificationDialog={() => {
              setTab(2);
              setHasNotEnoughQuotas(false);
            }
          }
          setNoCache={() => { }}
        />
    </>
  );
}

export default TabConfirmation;
